export const textsNotFoundPage: string[] = [
    'Неправильно набран адрес или такой страницы не существует',
    'Ошибка',
    'Ошибка сервера'
]